import types from '../actions/types';
import { yearsRange } from '../helpers';

const initialState = {
  tarifas: [],
  motores: [],
  materiales: [],
  materialesSoloFibra: [{'clave': '2', 'valor': 'FIBRA'}],
  tiposBarco: [],
  banderas: [],
  años: yearsRange(new Date().getFullYear(), 20, -1),
  accidenteOpciones:   [{clave: '1', valor: 'Si'}, {clave: '0', valor: 'No'}],
  extVigenciaOpciones: [{clave: '1', valor: 'Si'}, {clave: '0', valor: 'No'}],

  // TODO: tarifa fija 2, si se pide mas de una, ver lista tarifas.
  tarifa: {value: "2", label: "YACHT STANDARD"},
  
  zonasResidencia: [],
  marinas: [],
  
  filesComments: ['Documento de identidad', 'Certificado de matrícula', 'Foto de la embarcación'],
};

const cleanableState = {
  nombre: '',
  marca: '',
  material: null,
  eslora: '',
  tipoBarco: null,
  accidente: null,

  año: null,
  motorMarca: null,
  manga: '',
  valor: '',
  bandera: null,
  velocidad: '',

  zonaResidencia: null,
  marina: null,
  extVigencia: null,
  extintores: '',
  extFechaExpiracion: '',
  
  matricula: '',
  motorNumero: '',

  observaciones: '',
  files: [null, null, null],
};

const yates = (state = {...initialState, ...cleanableState}, action) => {
  switch (action.type) {

    case types.CLEAN:
      return { 
        ...state, 
        ...cleanableState,
        files: [null, null, null],
      };

    case types.SET_YATES_VALUE: {
      const { type, value } = action.payload;
      return {
        ...state,
        [type]: value
      }
    };

    default:
      return state;
  }
};

export default yates;
